import * as types from './constants';

export default {
    [types.SET_LIST_CLASS](state, data) {
        state.classLists = data;
    },
    [types.SET_LIST_SUBJECT](state, data) {
        state.subjectLists = data;
    },
    [types.GET_LIST_MEMBER](state, data) {
        state.memberLists = data;
    },
    [types.GET_LIST_DOCUMENT](state, data) {
        state.documentLists = data;
    },
    [types.SET_EVENT_CALENDAR](state, data) {
        state.events = data;
    },
    [types.SET_PARAM_LIST_SCHOOL](state, data) {
        state.getParamListSchool = data;
    },
    [types.GET_COURSE_DETAIL](state, data) {
        state.getCourseDetail = data;
    },
    [types.CLASS_SCHOOL_LIST_MEMBER](state, data) {
        state.getClassListMember = data;
    },
    [types.GET_LIST_LESSON_PLAN](state, data) {
        state.getListLesonPlan = data;
    },
    [types.SET_PARAM_DOCCUMENT](state, data) {
        state.getParamDoccument = data;
    },
    [types.GET_LIST_CLASS_DOCCUMENT](state, data) {
        state.getListClassDoccument = data;
    },
    [types.GET_LIST_CLASS_EVENT](state, data) {
        state.getListEvent = data;
    },
    [types.GET_DETAIL_EVENT](state, data) {
        state.getDetailEvent = data;
    },
    [types.GET_LIST_CLASS_POSITION](state, data) {
        state.getListClassPostion = data;
    },
};